import React from 'react';
import Spinner from 'react-spinkit';
import { Link } from 'react-router';
import { Row, Col } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { tableOptions as options } from '../../config';
import AddWaitlistModal from './AddWaitlistModal';

class WaitlistList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: []
    };
  }

  componentDidMount() {
    const { students } = this.props;
    this.setState({ students });
  }

  handleDeleteWaitlist = id => () => {
    // const { id: courseId } = this.props.course;
    this.props.courseActions.deleteWaitlist(id).then(() => {
      this.props.updateWaitlistList();
    });
  };

  handleBumpWaitlist = id => () => {
    // const { id: courseId } = this.props.course;
    this.props.courseActions.bumpWaitlist(id).then(() => {
      this.props.updateWaitlistList();
    });
  };

  parseItems = (items = []) => {
    const { students = [] } = this.props;
    if (students.length === 0) return [];
    return items.map(item => {
      const student = students.filter(student => student.id === item.student)[0] || {};
      return {
        ...item,
        studentEmail: student.user.email,
        studentId: item.student
      };
    });
  };

  formatEmail = (cell, row) => (
    <Link to={`/administer/${this.props.runSlug}/student/${row.studentId}`} className="class-name">
      <span>{row.studentEmail}</span>
    </Link>
  );
  formatAction = waitlistId => (
    <span onClick={this.handleDeleteWaitlist(waitlistId)}>
      <i className="fa fa-minus-circle" />
    </span>
  );
  formatBump = waitlistId => (
    <button className="btn btn-raw" onClick={this.handleBumpWaitlist(waitlistId)}>
      BUMP
    </button>
  );

  openWaitlistModal = () => {
    this.setState({
      showAddStudentsModal: true,
      studentsModalValues: {
        title: 'Add Student to Waitlist',
        courseId: this.props.course.id,
        initialValues: {}
      }
    });
  };

  renderContent = () => {
    const { isLoading, items = [] } = this.props;
    const parsedItems = this.parseItems(items);

    if (isLoading)
      return (
        <div className="mt-4">
          <Spinner spinnerName="three-bounce" />
        </div>
      );
    if (items.length === 0)
      return (
        <div className="mt-4">
          <p>0 on waitlist</p>
        </div>
      );
    return (
    <div className="c-table classes-table fontSmall">
      <BootstrapTable data={parsedItems} bordered={false} hover={true} condensed={true} options={options}>
        <TableHeaderColumn
          dataField="studentEmail"
          isKey={true}
          dataSort={true}
          dataFormat={this.formatEmail}
          width="40%"
        >
          Email address
            </TableHeaderColumn>
        <TableHeaderColumn dataField="studentId" width="10%" dataSort={true}>
          Identifier
            </TableHeaderColumn>
        <TableHeaderColumn
          dataField="waitlist_position"
          width="20%"
          dataSort={true}
          dataFormat={this.formatGrading}
        >
          Waitlist Position
            </TableHeaderColumn>
        <TableHeaderColumn dataField="id" width="5%" dataFormat={this.formatAction}>
          {' '}
        </TableHeaderColumn>
        <TableHeaderColumn dataField="id" width="5%" dataFormat={this.formatBump}>
          {' '}
        </TableHeaderColumn>
      </BootstrapTable>
    </div>
    )
  }

  closeAddStudentsModal = () => {
    this.setState({ showAddStudentsModal: false });
  };


  render() {
    const { items = [] } = this.props;

    
    return (
      <div className="mt-4">
        <div className="page-subtitle">
          <Row>
            <Col md={8}>
              <span>Waitlist</span>
            </Col>
            <Col md={4}>
              <button type="button" className="btn btn-block btn-ter" onClick={this.openWaitlistModal}>
                Add student to waitlist
              </button>
            </Col>
          </Row>
          <AddWaitlistModal
            closeModal={this.closeAddStudentsModal}
            showModal={this.state.showAddStudentsModal}
            onCancel={this.closeAddStudentsModal}
            initial={this.state.studentsModalValues}
            update={this.props.updateWaitlistList}
            assignments={items}
          />
        </div>
        {this.renderContent()}
      </div>
    );
  }
}

export default WaitlistList;



// WEBPACK FOOTER //
// ./src/components/classes/Waitlist.js